import type { JoinedUser } from '../types'

/**
 * List of users who have joined the whitelist
 */
export const JOINED_USERS: JoinedUser[] = [
  {
    name: 'acaldas',
    avatar: 'https://avatars.githubusercontent.com/u/5501872?v=4',
  },
  {
    name: 'Ryan Wolhuter',
    avatar: 'https://avatars.githubusercontent.com/u/39741965?v=4',
  },
  {
    name: 'Guillermo Puente Sandoval',
    avatar: 'https://avatars.githubusercontent.com/u/20387722?v=4',
  },
  {
    name: 'Frank',
    avatar: 'https://avatars.githubusercontent.com/u/1188574?v=4',
  },
  {
    name: 'Benjamin Jordan',
    avatar: 'https://avatars.githubusercontent.com/u/528526?v=4',
  },
  {
    name: 'Manuel Alejandro',
    avatar: 'https://avatars.githubusercontent.com/u/96558830?v=4',
  },
  {
    name: 'Yasiel Cabrera',
    avatar: 'https://avatars.githubusercontent.com/u/29311855?v=4',
  },
  {
    name: 'CallmeT-ty',
    avatar: 'https://avatars.githubusercontent.com/u/148560082?v=4',
  },
  {
    name: 'liberuum',
    avatar: 'https://avatars.githubusercontent.com/u/19393057?v=4',
  },
  {
    name: 'Wouter Kampmann',
    avatar: 'https://avatars.githubusercontent.com/u/1241878?v=4',
  },
  {
    name: 'DianaTahiri',
    avatar: 'https://avatars.githubusercontent.com/u/101014218?v=4',
  },
]
